import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getUserInfo } from "../utils/auth";
import CryptoJS from "crypto-js";

const Header = () => {
  const [userEmail, setUserEmail] = useState("");

  const setUserDetails = () => {
    const userInfo = getUserInfo();
    const ENCRYPT_DECRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;
    const bytes = CryptoJS.AES.decrypt(userInfo, ENCRYPT_DECRYPTION_KEY);
    const decryptedUserDetails = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    const words = decryptedUserDetails.email.split("@");
    setUserEmail(words[0]);
  };

  useEffect(() => {
    setUserDetails();
  }, []);

  return (
    <header className="bg-primary navbar sticky-top flex-md-nowrap p-0">
      <a
        className="navbar-brand col-md-3 col-lg-2 me-0 px-3 fs-6 text-white"
        href="#"
      >
        Casual Tech
      </a>
      <div style={{ padding: "10px", color: "white", fontWeight: "bold" }}>
        Hi {userEmail}
      </div>

      <ul className="navbar-nav flex-row d-md-none">
        <li className="nav-item text-nowrap">
          <button
            data-mdb-button-init
            className="navbar-toggler second-button text-white"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#sidebarMenu"
            aria-controls="sidebarMenu"
            aria-expanded="false"
            aria-label="Toggle navigation"
            style={{ margin: "10px" }}
          >
            <i className="fa fa-bars"></i>
          </button>
        </li>
      </ul>

      <div id="navbarSearch" className="navbar-search w-100 collapse">
        <input
          className="form-control w-100 rounded-0 border-0"
          type="text"
          placeholder="Search"
          aria-label="Search"
        />
      </div>
    </header>
  );
};

export default Header;
